import type { ServerResponse } from 'node:http';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import { encryptShortcutCodeNavBody } from './e2ee/encrypt-code-nav-body.js';
import { encryptShortcutFileBrowserBody } from './e2ee/encrypt-file-browser-body.js';

export function sendShortcutJson(res: ServerResponse, status: number, body: unknown): void {
  if (res.headersSent) return;
  res.writeHead(status, { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' });
  res.end(JSON.stringify(body));
}

/** File-browser JSON body; encrypts sensitive fields when E2EE is active (matches cloud `{ ee }` responses). */
export function sendShortcutFileBrowserJson(
  res: ServerResponse,
  status: number,
  body: Record<string, unknown>,
  e2ee: CliE2eeRuntime | undefined,
): void {
  sendShortcutJson(res, status, encryptShortcutFileBrowserBody(body, e2ee));
}

/** Code-nav JSON body; encrypts sensitive fields when E2EE is active (matches cloud `{ ee }` responses). */
export function sendShortcutCodeNavJson(
  res: ServerResponse,
  status: number,
  body: Record<string, unknown>,
  e2ee: CliE2eeRuntime | undefined,
): void {
  sendShortcutJson(res, status, encryptShortcutCodeNavBody(body, e2ee));
}
